import { createContext, useContext } from "react";
import type {
  NotificationDeliverabilityStatus,
  NotificationPermissionState,
} from "./notification-deliverability";

export type NotificationDeliverabilityContextValue = {
  status: NotificationDeliverabilityStatus;
  permissionState: NotificationPermissionState;
  isLoading: boolean;
  error: string | null;
  requestPermission: () => Promise<string | null>;
  refreshPermission: () => Promise<void>;
  retryRegistration: () => void;
  revokeRegisteredDevice: () => Promise<void>;
  openDeviceSettings: () => Promise<void>;
};

const DEFAULT_CONTEXT: NotificationDeliverabilityContextValue = {
  status: "unsupported",
  permissionState: "unsupported",
  isLoading: false,
  error: null,
  requestPermission: async () => null,
  refreshPermission: async () => {},
  retryRegistration: () => {},
  revokeRegisteredDevice: async () => {},
  openDeviceSettings: async () => {},
};

export const NotificationDeliverabilityContext =
  createContext<NotificationDeliverabilityContextValue>(DEFAULT_CONTEXT);

export function useNotificationDeliverability() {
  return useContext(NotificationDeliverabilityContext);
}
